import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PosIntegrationService } from '../../../../../services/pos-integration.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-link-teamwork',
  templateUrl: './link-teamwork.component.html',
  styleUrls: ['./link-teamwork.component.scss']
})
export class LinkTeamworkComponent {
  @Input() partner;
  @Input() selectedPOS;
  @Input() modal;
  @Output() next = new EventEmitter();


  public apiKey: string = '';
  public apiUrl: string = '';
  public busy: boolean = false;
  public connected: boolean = false;
  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private posIntegrationService: PosIntegrationService,
    private translate: TranslateService,
  ) { }

  ngOnInit() {
    this.busy = false;
  }

  SaveSettings() {
    this.posIntegrationService
      .savePOSConnection(this.partner.PartnerID, {
        PartnerID: this.partner.PartnerID,
        POSID: 20,
        AccessToken: this.apiKey,
        APIKey: this.apiKey,
        APIUrl: this.apiUrl,
      })
      .subscribe((x) => {
        if (this.modal !== undefined) this.modal.dismiss('Cross click');
        else this.next.emit();
      });
  }
}
